<template>
  <div
    class="subtitle-container"
    :data-text="text"
  >
    <p class="inner-subtitle">{{ text }}</p>
  </div>
</template>
<script>

export default {
  props: {
    text: {
      type: String,
      default: ''
    }
  }
};
</script>
<style lang="scss">
  @import "./index.scss";
</style>
